import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const LogoMark = ({ className = "w-9 h-9", testId, animate = false }) => (
  <span className={`relative inline-block ${className}`} data-testid={testId}>
    <svg viewBox="0 0 80 80" className="absolute inset-0 w-full h-full" aria-hidden="true">
      <motion.rect
        x="3" y="3" width="74" height="74"
        fill="none" stroke="#14B8A6" strokeOpacity="0.55" strokeWidth="1.5"
        vectorEffect="non-scaling-stroke"
        initial={animate ? { pathLength: 0 } : false}
        animate={animate ? { pathLength: 1 } : undefined}
        transition={{ duration: 1.1, delay: 0, ease: EASE }}
      />
    </svg>
    <motion.img
      src="/hummingbird.png"
      alt="Calliope hummingbird logo"
      className="w-full h-full object-contain p-[13%]"
      initial={animate ? { opacity: 0, scale: 0.8 } : false}
      animate={animate ? { opacity: 1, scale: 1 } : undefined}
      transition={{ duration: 0.9, delay: 0.8, ease: EASE }}
    />
  </span>
);
